import IMask from 'imask';

const initForm = ()=> {
    const initFormInputs = () => {
        // console.log('forms.js');

        let completed = false;

        const inputPhoneElms = document.querySelectorAll('.input--phone-mask');
        inputPhoneElms.forEach((item) => {
            const maskPhone = IMask(
                item,
                {
                    mask: '{\\+373} 000 000 00',
                    // lazy: false,
                    placeholderChar: 'X'
                }
            )

            maskPhone.on('complete', () => {
                completed = true
                // console.log('completed');
            });
        });


        const inputDateElms = document.querySelectorAll('.input--date-mask');
        inputDateElms.forEach((item) => {
            const maskDate = IMask(
                item,
                {
                    mask: Date,
                    // min: new Date(1990, 0, 1),
                    // max: new Date(2020, 0, 1),
                    // placeholderChar: '/'
                }
            )
            maskDate.on('complete', () => {
                completed = true
                // console.log('completed');
            });
        });


        //input only numbers
        const formInputOnlyNumbersElms = document.querySelectorAll('.input--only-numbers');
        formInputOnlyNumbersElms.forEach((item) => {
            item.addEventListener('input', function() {
                // item.value = item.value.replace(/\D/g, '');
                item.value = item.value.replace(/[^0-9]/g, '')
            });
        });

        //toggle password
        const formTogglePasswordElms = document.querySelectorAll('[data-toggle-password]');
        formTogglePasswordElms.forEach((button) => {
            button.addEventListener('click', function() {
                const input = button.previousElementSibling;
                if (input.type === 'password') {
                    input.type = 'text';
                    button.classList.add('shown')
                } else {
                    input.type = 'password';
                    button.classList.remove('shown')
                }
            });
        });

        const formElms = document.querySelectorAll('.form__block');

        formElms.forEach((formElm) => {
            const inputFields = formElm.querySelectorAll('input[type="text"], input[type="password"], input[type="tel"], textarea');
            const formLabelElms = formElm.querySelectorAll('.form__item_label');
            inputFields.forEach(input => {
                input.addEventListener('input', function() {
                    // console.log('input change 1', input);
                    if (input.closest('.form__item')) {
                        removeFieldError(input);
                    }
                })
            });

            const checkboxFields = formElm.querySelectorAll('input[type="checkbox"]');
            checkboxFields.forEach(input => {
                input.addEventListener('change', function() {
                    // console.log('input change 2', input);
                    if (input.closest('.form__item')) {
                        removeFieldError(input);
                    }
                })
            });


            const selectFields = formElm.querySelectorAll('select');
            selectFields.forEach(select => {
                select.addEventListener('change', function() {
                    // console.log('select change', select);
                    removeFieldError(select);
                });
            });





            function checkInputValue(item) {
                const itemParentElm = item.closest('.form__item');
                if (item.value !== '') {
                    // console.log('item.value', item.value);
                    // if (item.type !== 'tel') {
                    itemParentElm.classList.add('has--value');
                    // } else if (item.type === 'tel' && completed) {
                    //     itemParentElm.classList.add('has--value');
                    // }
                } else {
                    itemParentElm.classList.remove('has--value');
                }
            }

            formLabelElms.forEach((item) => {
                item.addEventListener('click', function() {
                    // console.log('click');
                    const inputElm = item.previousElementSibling;
                    inputElm.focus();
                });
            });


            inputFields.forEach((item) => {

                checkInputValue(item);

                // console.log('item', item);

                item.addEventListener('focus click', function() {
                    checkInputValue(item);
                });
                item.addEventListener('blur', function() {
                    checkInputValue(item);
                });

            });

        });

    }

    const renderFormErrors = (error, formElm) => {
        if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            const formDataClass = formElm.dataset.form;
            // console.log('formDataClass', formDataClass);
            for (const field in errors) {
                // const errorField = `${field}-error`;
                const errorField = `${formDataClass}-${field}-error`;
                // console.log('errorField', errorField);
                showFieldError(errorField, errors[field], formElm);
            }
        }
    }
    const showFieldError = (errorField, errorMessage, formElm) => {
        const errorElement = formElm.querySelector('#'+errorField);
        // console.log('errorElement', errorElement);
        if (errorElement) {
            errorElement.textContent = errorMessage[0];
            errorElement.closest('.form__item').classList.add('has--error');
        }
    }
    const removeFieldError = (input) => {
        const errorElement = input.closest('.form__item').querySelector('.form__item_error');
        if (errorElement && input.value.trim() !== '') {
            errorElement.textContent = '';
            input.closest('.form__item').classList.remove('has--error');
        }
    }

    return {
        initFormInputs,
        renderFormErrors,
        removeFieldError
    }

}

export default initForm;
